:host {
  position: relative;
  display: block;
}

.vx-selected-filter {
  display: flex;
  flex-wrap: wrap;
  gap: var(--vx-selected-filter--flex-gap, 16px);
  margin-bottom: var(--vx-selected-filter--margin-bottom, 14px);
}

.vx-selected-filter__button {
  position: absolute;
  right: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  color: var(--vx-selected-filter--clear-all-color, #000);
  width: auto;
  height: auto;
  background: none;
  border: none;
  appearance: none;
  padding: 8px 16px;
  border-radius: 16px;
}
.vx-selected-filter__button:focus, .vx-selected-filter__button:active, .vx-selected-filter__button:hover {
  outline: none !important;
  background-color: var(--vx-selected-filter-tag--hover-bg, #00869d);
  color: #fff;
}

@media only screen and (min-width: 768px) {
  :host {
    padding-bottom: 30px;
  }
  .vx-selected-filter__button {
    left: 0;
    right: auto;
    bottom: 0;
  }
}